/**
 * Copyright (c) 2020 Intelligent Software Research Center of ISCAS
 * Summer 2020 Homepage is licensed under Mulan PSL v2.
 * You can use this software according to the terms and conditions of the Mulan PSL v2.
 * You may obtain a copy of Mulan PSL v2 at:
 *          http://license.coscl.org.cn/MulanPSL2
 * THIS SOFTWARE IS PROVIDED ON AN "AS IS" BASIS, WITHOUT WARRANTIES OF ANY KIND,
 * EITHER EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO NON-INFRINGEMENT,
 * MERCHANTABILITY OR FIT FOR A PARTICULAR PURPOSE.
 * See the Mulan PSL v2 for more details.
 */

import React, { useEffect, useState } from 'react'

import { connect } from 'react-redux'

import { Input, Pagination } from 'antd'
import pinyin from 'pinyin'
import _ from 'lodash'
import { getSplit, gohash } from '../../util/url.js'

import fintermlist from '../../data/finterm.json'
import proData from '../../data/fintermdata.json'
import eliteStuData from '../../data/elitestudata.json'

import './index.less'

const { Search } = Input

const Fintermdata = props => {
  const [tabFlag, setTabFlag] = useState('0')

  const [page, setPage] = useState(1)
  const [pagesize, setPagesize] = useState(100)
  const [datall, setDataall] = useState(proData)

  const [searchdatastock, setSearchdatastock] = useState([])
  const [datastock, setDatastock] = useState(proData)

  const [fintermdata, setFintermdata] = useState([])

  useEffect(() => {
    getData()
  }, [])

  const getData = () => {
    //处理中选项目按学生姓名排序
    let oriPro = datall
    oriPro.forEach(item => {
      item.selectedStudentList = [item.name]
      if (item.selectedStudentList[0] != '-') {
        item['FL'] = item.selectedStudentList
          .map(itemPY => {
            return pinyin(itemPY.substr(0, 1), { style: pinyin.STYLE_FIRST_LETTER }).flat()[0]
          })
          .sort()[0]
      } else {
        item['FL'] = 'zzz'
      }
      item.selectedStudentList = item.selectedStudentList.sort((param1, param2) => param1.localeCompare(param2, 'zh'))
    })
    let sortDatall = _.orderBy(oriPro, ['FL'], ['asc'])
    setDataall(sortDatall)
    setDatastock(sortDatall)
    setFintermdata(sortDatall.slice(0, pagesize))
  }

  const itemRender = (current, type, originalElement) => {
    if (props.chiFlag === 'chi') {
      if (type === 'prev') return <a>上一页</a>
      if (type === 'next') return <a>下一页</a>
    } else {
      if (type === 'prev') return <a>Previous</a>
      if (type === 'next') return <a>Next</a>
    }
    return originalElement
  }

  const gohashlink = (orgtitle, proid) => {
    let url = '/org/orgdetail/' + orgtitle
    if (proid) {
      url += '/proid' + proid
    }
    gohash(url)
    props.setOrgTabFlag('orglist')
  }

  const onChange = page => {
    getPageData(page)
  }

  const getPageData = page => {
    setPage(page)
    setFintermdata(datall.slice(pagesize * (page - 1), pagesize * page))
  }

  const filterItem = value => {
    if (value) {
      const showdataTemp = datastock.filter(item => item.name.includes(value))
      setDataall(showdataTemp)
      setFintermdata(showdataTemp.slice(pagesize * (page - 1), pagesize * page))
      setSearchdatastock(showdataTemp)
      setPage(1)
    } else {
      setDataall(datastock)
      setFintermdata(datastock.slice(pagesize * (page - 1), pagesize * page))
      setSearchdatastock([])
      setPage(1)
    }
  }

  const showdata = fintermlist[props.chiFlag]
  const datalllength = datall.length

  const PassList = () => {
    return (
      <>
        <div className="finterm-search">
          <Search placeholder={showdata.searchPlaceholder} allowClear size="large" onSearch={value => filterItem(value)} />
        </div>
        <div className="finterm-wrapper">
          <div className="finterm-pageState content1200">
            <div className="finterm-page">
              <span className="finterm-pageItemOne">
                {showdata.pronum[0]} {datalllength} {showdata.pronum[1]}
              </span>
              <span className="finterm-pageItem">
                {showdata.pagenum[0]} {page} {showdata.pagenum[1]}
              </span>
              <span className="finterm-pageItemSum">
                {showdata.pagesum[0]} {Math.ceil(datalllength / pagesize)} {showdata.pagesum[1]}
              </span>
            </div>
            <div className="sort-description">{showdata.sortDes}</div>
          </div>
          <div className="finterm-table content1200">
            <div className="table-header">
              <span className="header-col w140">{showdata.studentName}</span>
              <span className="header-col w400 text-left">{showdata.projectName}</span>
              <span className="header-col w185">{showdata.projectCommunity}</span>
              <span className="header-col w185">{showdata.communityTeacher}</span>
              <span className="header-col w185">{showdata.fintermresult}</span>
              <span className="header-col w110">{showdata.storage}</span>
            </div>
            {fintermdata.map((item, index) => {
              return (
                <div className="table-row" key={index}>
                  <span className="row-item w140">{item.name}</span>
                  <span
                    className="row-item w400 blue text-left single-ellipsis cursor-pointer"
                    onClick={() => {
                      gohashlink(item.anchor, item.projectid)
                    }}
                  >
                    {getSplit(item.projectname, props.chiFlag)}
                  </span>
                  <span className="row-item w185">{item.communityname}</span>
                  <span className="row-item w185">{item.tutor}</span>
                  <span className="row-item w185">{showdata.pass}</span>
                  <span className="row-item w110 blue cursor-pointer" onClick={() => window.open(item.repolink)}>
                    {showdata.access}
                  </span>
                </div>
              )
            })}
          </div>
          <div className="finterm-pagination content1200">
            <Pagination current={page} defaultPageSize={pagesize} total={datalllength} itemRender={itemRender} onChange={onChange} showSizeChanger={false} />
          </div>
        </div>
      </>
    )
  }

  const StuList = () => {
    return (
      <div className="stuList-content">
        <div className="content-intro">{showdata.stu_info.intro}</div>
        {showdata.stu_info.award.map((item, index) => {
          return (
            <div className="content-table" key={index}>
              <div className="table-img">
                <img src={require(`../../img/finterm/best-quality-award.png`).default} />
                <div className="img-txt">{item.title}</div>
              </div>
              <div className="table-box content1200">
                <div className="table-page">{item.total}</div>
                <div className="stu-table">
                  <div className="table-header">
                    <span className="header-col w160">{showdata.studentName}</span>
                    <span className="header-col w550 text-left">{showdata.projectName}</span>
                    <span className="header-col w185">{showdata.projectCommunity}</span>
                    <span className="header-col w200">{showdata.communityTeacher}</span>
                    <span className="header-col w110">{showdata.storage}</span>
                  </div>
                  {eliteStuData[item.key].map((item, index) => {
                    return (
                      <div className="table-row" key={index}>
                        <span className="row-item w160">{item.name}</span>
                        <span
                          className="row-item w550 blue text-left single-ellipsis cursor-pointer"
                          onClick={() => {
                            gohashlink(item.anchor, item.projectid)
                          }}
                        >
                          {getSplit(item.projectname, props.chiFlag)}
                        </span>
                        <span className="row-item w185">{item.communityname}</span>
                        <span className="row-item w200">{item.tutor}</span>
                        <span className="row-item w110 blue cursor-pointer" onClick={() => window.open(item.repolink)}>
                          {showdata.access}
                        </span>
                      </div>
                    )
                  })}
                </div>
              </div>
            </div>
          )
        })}

        <div className="stu-role">
          <div className="role-list">
            <div className="list-tit">{showdata.stu_info.role_list.title}</div>
            <div className="list-item">
              {showdata.stu_info.role_list.text.map(item => (
                <div>{item}</div>
              ))}
            </div>
            <div style={{ marginTop: '60px' }} className="list-tit">
              {showdata.stu_info.role_list.title}
            </div>
            <div className="list-item">
              {showdata.stu_info.flow_list.text.map(item => (
                <div>{item}</div>
              ))}
            </div>
            <div style={{ marginTop: '60px' }} className="list-tit">
              {showdata.stu_info.tips}
            </div>
          </div>
        </div>
      </div>
    )
  }

  return (
    <div className="finterm">
      <div className="finterm-header">
        <div className="finterm-header-des">
          <div className={props.chiFlag === 'chi' ? 'finterm-title-chi' : 'finterm-title-en'}>{showdata.banner_title}</div>
          <div className={props.chiFlag === 'chi' ? 'finterm-text-chi' : 'finterm-text-en'}>{showdata.banner_text}</div>
        </div>
      </div>
      <div className="finterm-tab">
        {showdata.tab.map((item, index) => {
          return (
            <div key={index} className={['tab-item', tabFlag === item.key ? 'active-tab' : ''].join(' ')} onClick={() => setTabFlag(item.key)}>
              {item.name}
            </div>
          )
        })}
      </div>
      {tabFlag === '0' ? <PassList /> : <StuList />}
    </div>
  )
}

const mapStateToProps = state => {
  return {
    chiFlag: state.chiFlag,
    studata: state.studata
  }
}

const mapDispatchToProps = dispatch => {
  return {
    setOrgTabFlag: data => {
      dispatch({
        type: 'setOrgTabFlag',
        payload: data
      })
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Fintermdata)
